import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NumberInputComponent } from '@navstation-portal/shared/ui/components';
import { injectDispatch } from '@ngrx/signals/events';
import { IsVisibleDirective } from '@navstation-portal/shared/ui/directives';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-crew-and-passengers',
  templateUrl: './crew-and-passengers.component.html',
  imports: [NumberInputComponent, FormsModule, IsVisibleDirective],
})
export class CrewAndPassengersComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'operational';
  sectionId = 'crewAndPassengers';
  events = injectDispatch(offshoreOperationalEvents);
  offshoreOperationalStore = inject(OffshoreOperationalFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
